import React, {useContext, useState} from 'react'
import {Button, Container, TextField} from '@material-ui/core'
import useFormState from './useFormState'
import {AppContext} from "../AppContext";

import firebase from 'firebase/app'
import {MessageContext} from "../MessageContext";


function Profile(props) {

    const context = useContext(AppContext)
    const messageContext = useContext(MessageContext)
    const [editMode, setEditMode] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null)
    const [name, setName] = useFormState(context.currentUser.name || "")
    const [company, setCompany] = useFormState(context.currentUser.company || "")
    const [bio, setBio] = useFormState(context.currentUser.bio || "")
    const [twitter_handle, setTwitterHandle] = useFormState(context.currentUser.twitter_handle || "")
    const [image_url, setImageUrl] = useState(context.currentUser.image_url)
    const [profilePictureChange, setProfilePictureChange] = useState(false)
    const uploader = document.getElementById('uploader')

    const toggleEdit = () => setEditMode(!editMode)

    const handleSubmit = (e) => {
        e.preventDefault()

        fetch(`${process.env.REACT_APP_API_CALL}/users/${context.currentUser.id}`, {
            method: "PATCH",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                name: name,
                twitter_handle: twitter_handle,
                company: company,
                image_url: image_url,
                bio: bio,
            })
        })
            .then(response => response.json())
            .then(response => {
                if (response.errors) {
                    alert(response.errors)
                } else {
                    context.updateLocalUser(response)
                    setEditMode(false)
                    messageContext.showSuccessMessage("Profile has been updated")
                }
            })
    }

    const fileSelectedHandler = event => {
        const file = event.target.files[0]
        setSelectedFile(file)
    }

    const fileUploadHandler = () => {
        const storageRef = firebase.storage().ref('profile_pics/' + selectedFile.name)
        const task = storageRef.put(selectedFile)

        task.on('state_changed',
            function progress(snapshot) {
                let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                uploader.value = percentage
            },
            function error(err) {},
            function complete() {
                storageRef.getDownloadURL()
                    .then((url) => {
                        setImageUrl(url)
                        sendUpdatedPictureToBackend(url)
                    })

            }
        )
    }

    const sendUpdatedPictureToBackend = (url) => {
        fetch(`${process.env.REACT_APP_API_CALL}/users/${context.currentUser.id}`, {
            method: "PATCH",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                image_url: url
            })
        })
    }

    const makeProfileBody = () => {
        return <div className="profile-body">
            <div className="profile-left-side">

                {
                    !editMode && <div>
                        <h3>Name: {name}</h3>
                        <h3>Company: {company}</h3>
                        <h3>Bio: {bio}</h3>
                        <h3>Twitter Handle: {twitter_handle}</h3>
                    </div>
                }

                {
                    editMode ?

                        <form onSubmit={handleSubmit}>
                            <TextField id="name" name="name" value={name} label="Name" onChange={setName}/><br/>
                            <TextField id="company" name="company" value={company} label="Company" onChange={setCompany}/><br/>
                            <TextField id="bio" name="bio" value={bio} multiline={true} label="Bio" onChange={setBio}/><br/>
                            <TextField id="twitter_handle" name="twitter_handle" value={twitter_handle} label="Twitter Handle" onChange={setTwitterHandle}/><br/>
                            <br />
                            <br />
                            <Button type="submit" variant="contained" color="primary">Update Profile</Button>
                        </form>

                        : null
                }

                {!editMode && <Button onClick={toggleEdit} variant="contained" color="primary">Edit Profile</Button>}
            </div>

            <div className="profile-right-side">
                <img src={image_url} alt="profile" height="400" width="400"/>
                <br/>
                {!profilePictureChange &&
                <Button onClick={() => setProfilePictureChange(true)}>Change Profile Picture</Button>
                }
                { profilePictureChange &&
                <>
                    <progress value="0" max="100" id="uploader">0%</progress><br/>
                    <input type="file" onChange={fileSelectedHandler} id="fileButton"/>
                    <Button onClick={fileUploadHandler} variant="contained" color="primary">Upload</Button>
                </>
                }

            </div>

        </div>
    }

    return <Container>
        {makeProfileBody()}
    </Container>

}

export default Profile